import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoreComponent } from './more.component';
import { MoreRoutingModule } from './more-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ListItemModule } from 'src/app/angular-core/components/list-item/list-item.module';
import { MessageDialogComponentModule } from 'src/app/angular-core/components/message-dialog/message-dialog.module'
import { LocalizedDateModule } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module';

@NgModule({
  declarations: [MoreComponent],
  imports: [
    CommonModule,
    MoreRoutingModule,
    MatIconModule,
    TranslateModule,
    ListItemModule,
    MessageDialogComponentModule,
    LocalizedDateModule,
  ],
  exports: [MoreComponent]
})
export class MoreModule { }
